import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { ClaimantsModel } from '../../models/claimantsmodel';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-file',
  templateUrl: './file.html',
  styleUrls: ['./file.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, BsDatepickerModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class File implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  policyDatePickerConfig: Partial<BsDatepickerConfig>;

  claimForm: FormGroup;
  allStates: any = [];
  allCountries: any = [];
  allCompanyHealthTypes: any = [];
  allRelationshipTypes: any = [];
  showDivOptSectionA: boolean = false;
  showDivOptSectionB: boolean = false;
  showDivOtherHealthType: boolean = false;
  showDivOtherRelationshipType: boolean = false;
  showDivAddPolicyDetailsMessage: boolean = false;
  submitted = false;
  clicked = false;
  supportingDocuments: File[] = [];
  cmList: any = [];
  cmPAList: any = [];
  pdList: any = [];
  submittedClaim: ClaimantsModel;
  response: string | undefined;
  

  validation_PolicyDetailsErrorMessage = {
    policyNumber: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 30 characters" },
      { type: "pattern", message: "This field accepts only numerical digits 0-9 characters A-Z or a-z" }
    ],
    totalPremiumPaid: [
      { type: 'required', message: 'This Field is required' },
      { type: "pattern", message: "You can only use up to 9 digits before and 2 digits past the decimal (.)" }
    ],
    policyDate: [
      { type: 'required', message: 'This Field is required' },
    ],
    brokerStreetAddress: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    brokerCity: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 40 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    brokerZipCode: [
      { type: "required", message: "This field is required" },
      { type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    brokerState: [
      { type: 'required', message: 'This Field is required' },
    ],
    brokerName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    brokerPhoneNumber: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 10 digits" },
      { type: "maxlength", message: "This field must not be at greater 10 digits<" },
      { type: "pattern", message: "Only use numbers" }
    ],
    lloydsSyndicateName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
  };

  //validation_FormErrorMessages = {
  //  acknowledgement: [
  //    { type: "required", message: "This field is required" }
  //  ],
  //};

  constructor(private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private tppClaimantService: ClaimantService) { }


  ngOnInit() {
    this.policyDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: new Date(1997, 0, 1),
        maxDate: new Date(2025, 3, 15),
        dateInputFormat: 'MM/DD/YYYY',
      });
    this.loadAllStates();
    this.claimForm = this.fb.group({
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name3: ['', Validators.compose([ Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phone1: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],   
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],    
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
      acknowledgement: [false, Validators.compose([Validators.requiredTrue])],
      policyDetails: this.fb.array([]),
    })
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.claimForm.controls; }


  // Clear Form Array Controls
  resetFormArray() {
    this.policyDetails().clear();
  }

  // Remove the second element and so on

  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  // Declare FormArray Function
  policyDetails(): FormArray {
    return this.claimForm.get('policyDetails') as FormArray
  }

  // Create new Form Array
  newPolicyDetail(): FormGroup {
    const moneyRegex = /^\d{0,9}(?:\.\d{1,2})?$/;
    const group =  this.fb.group({
      policyNumber: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9]+$")])],
      totalPremiumPaid: ['', Validators.compose([Validators.required, Validators.pattern(moneyRegex)])],
      policyDate: ['', Validators.compose([Validators.required])],
      brokerName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      lloydsSyndicateName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      brokerStreetAddress: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      brokerCity: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      brokerState: ['', Validators.compose([Validators.required])],
      brokerZipCode: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      brokerPhoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],      
    });

    // Automatically uppercase policyNumber
    group.get('policyNumber')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        group.get('policyNumber')?.setValue(
          value.toUpperCase(),
          { emitEvent: false }
        );
      }
    });

    return group;
  }

  // Create a New Array Function
  policyDetailARR(index) {
    this.pdList = this.claimForm.get('policyDetails') as FormArray;
    const formGroup = this.pdList.controls[index] as FormGroup;
    return formGroup;
  }

  // Create a New Array Function
  addPolicyDetail() {
    //this.showDivOtherSchoolName = false;
    this.showDivAddPolicyDetailsMessage = false;
    (<FormArray>this.claimForm.get('policyDetails')).push(this.newPolicyDetail());
    /*this.showDivEmptyCheckboxMessage = true;*/
  }

  removePolicyDetail(i: number) {
    this.policyDetails().removeAt(i)
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.claimForm.invalid) {
      return;
    }


    for (let i = 0; i < this.policyDetails().length; i++) {
      let pDate = formatDate(this.policyDetails().at(i).get('policyDate').value, 'yyyy-MM-dd', 'en-US');
      this.policyDetails().at(i).get('policyDate').setValue(pDate);
    }

    this.clicked = true;
    const claimant = this.claimForm.value;

    this.spinner.show();

    console.log(claimant);
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: ClaimantsModel) {
    this.tppClaimantService.createClaimant(claimant).subscribe({
      next: (res) => {
        this.storage.store('claimant', res);
        this.claimForm.reset();
        this.spinner.hide();
        this.router.navigate(['/complete']);
      },
      error: err => {
        this.spinner.hide();
        console.group('Claimant submission failed');
        console.log('Status:', err.status);
        console.log('Error:', err.error);
        console.groupEnd();
      }
    });
  }
}
